import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

Vue.config.optionMergeStrategies.__i18n = (parent, child) => {
  return (child || []).concat(parent || [])
}

export default new VueI18n({
  locale: 'de',
  fallbackLocale: 'en'
})
